import { Injectable, ErrorHandler, Injector } from '@angular/core';
import { ClientMonitoringService } from './client-monitoring.service';

@Injectable()
export class ClientMonitoringErrorHandler extends ErrorHandler {
    constructor(private injector: Injector) {
        super();
    }

    handleError(error: any): void {
        const clientMonitoringService = this.injector.get(ClientMonitoringService);
        clientMonitoringService.trackException(error);
        super.handleError(error);
    }
}